import { Button, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useMemo, useState } from "react";
import { commaSeparateNumber, hasPermission } from "../../../utils/functions";
import { CARTON_INVENTORY_CREATE_PERMISSION } from "../../../routes/permissions";
import ListTable from "common/ListTable";
import ItemAssignDrawer from "../ItemAssignDrawer";

const formatDimensions = (row) => {
  const parts = [row.length, row.width, row.height].filter((v) => v != null && v !== "");
  return parts.length ? parts.join("×") : "—";
};

const BreakdownTable = ({ breakdowns = [], movement, disabled }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeRow, setActiveRow] = useState(null);

  const dataSource = useMemo(
    () =>
      (breakdowns || []).map((row) => ({
        ...row,
        key: row.id,
        item_type_name: row.item_category?.name,
        po_label: row.po_map?.original_po || "—",
        style_label: row.style?.style_no || "—",
        carton_type_name: row.carton_type?.name || "—",
        ply_name: row.ply?.name || "—",
      })),
    [breakdowns],
  );

  const openDrawerForRow = (row) => {
    setActiveRow(row);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setActiveRow(null);
  };

  const columns = [
    {
      title: "PO",
      dataIndex: "po_label",
      key: "po_label",
      width: 90,
      ellipsis: true,
    },
    {
      title: "Style",
      dataIndex: "style_label",
      key: "style_label",
      width: 110,
      ellipsis: true,
    },
    {
      title: "Category",
      dataIndex: "item_type_name",
      key: "item_type_name",
      width: 100,
      ellipsis: true,
    },
    {
      title: "Carton Type",
      dataIndex: "carton_type_name",
      key: "carton_type_name",
      width: 130,
      ellipsis: true,
    },
    {
      title: "Ply",
      dataIndex: "ply_name",
      key: "ply_name",
      width: 70,
      ellipsis: true,
    },
    {
      title: "G.Qty",
      dataIndex: "garment_qty",
      key: "garment_qty",
      width: 70,
      align: "right",
      render: (v) => (v != null ? commaSeparateNumber(v) : "—"),
    },
    {
      title: "C.Qty",
      dataIndex: "carton_total_qty",
      key: "carton_total_qty",
      width: 70,
      align: "right",
      render: (v) => (v != null ? commaSeparateNumber(v) : "—"),
    },
    {
      title: "L×W×H",
      key: "dimensions",
      width: 80,
      render: (_, row) => formatDimensions(row),
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      width: 70,
      align: "right",
      render: (v) => (v != null ? commaSeparateNumber(v) : "—"),
    },
    {
      title: "Total",
      dataIndex: "total_amount",
      key: "total_amount",
      width: 80,
      align: "right",
      render: (v) => (v != null ? commaSeparateNumber(v) : "—"),
    },
    {
      title: "Action",
      key: "action",
      width: 80,
      align: "center",
      fixed: "right",
      render: (_, row) => (
        <Button
          type="primary"
          size="small"
          icon={<PlusOutlined />}
          disabled={disabled || !movement || !hasPermission([CARTON_INVENTORY_CREATE_PERMISSION])}
          onClick={() => openDrawerForRow(row)}
        >
          Add
        </Button>
      ),
    },
  ];

  return (
    <Card title="Breakdown" size="small" className="mt-3">
      <ListTable
        bordered
        size="small"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        scroll={{ x: "max-content" }}
        locale={{ emptyText: "Select a supplier PO to load breakdown items" }}
      />
      <ItemAssignDrawer
        open={drawerOpen}
        onClose={closeDrawer}
        selectedRows={activeRow ? [activeRow] : []}
        movement={movement}
        tableType="breakdown"
      />
    </Card>
  );
};

export default BreakdownTable;
